import styles from "./ImagePreview.module.css";
import React, { useState, useEffect } from "react";
import LoadingSpinner from "../../LayoutComponents/LoadingSpinner";

const ImagePreview = ({ imageUrl }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (imageUrl) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [imageUrl]);

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
  };

  return (
    <div className={styles.imagePreview}>
      {loading && <LoadingSpinner />}

      {imageUrl && (
        <img
          src={imageUrl}
          alt=""
          className={loading ? styles.hidden : styles.image}
          onLoad={handleLoad}
          onError={handleError}
          style={{ display: loading ? "none" : "block" }}
        />
      )}
    </div>
  );
};

export default ImagePreview;
